import { IContractState } from '@/store/contract';
import { IContractGetters } from './getters.types';
import { IContract, Contract, IContractItem, ContractItem } from '@/models';

export const getters: IContractGetters = {
  getContractCount(state: IContractState): number {
    return state.count;
  },

  getContracts(state: IContractState): IContract[] {
    return state.contracts.map(data => new Contract(data));
  },

  getContractById: (state: IContractState) => (
    id: number
  ): IContract | undefined => {
    const data = state.contracts.find(contract => contract.id === id);
    if (!data) {
      return undefined;
    }

    return new Contract(data);
  },

  getContractItemById: (state: IContractState) => (
    contractId: number,
    itemId: number
  ): IContractItem | undefined => {
    const contract = state.contracts.find(
      contract => contract.id === contractId
    );
    if (contract) {
      const item = contract.items!.find(contract => contract.id === itemId);
      if (item) {
        return new ContractItem(item);
      }
    }

    return undefined;
  }
};
